<template>
  <div>
    <el-dialog width="40%" title="Limite de crédito do cliente" :visible.sync="dialog" append-to-body>
      <el-tag type="info">Limite Atual: {{ current }}</el-tag
      ><el-tag type="primary">Novo Limite: {{ newLimit }}</el-tag>
      <el-divider />
      <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
        <el-form-item label="Limite" class="is-required">
          <el-input type="text" v-money.lazy="money" ref="money" v-model="ruleForm.limit"> </el-input>
        </el-form-item>
        <br />
        <el-button type="success" @click="add">Adicionar</el-button>
        <el-button type="danger" @click="remove">Remover</el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">Cancelar</el-button>
        <el-button type="warning" @click="save">Confirmar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import MoneyMixins from "../../../../mixins/money";

export default {
  name: "CustomerLimit",
  mixins: [MoneyMixins],
  props: ["limit"],
  computed: {
    current() {
      console.log("this.limit", this.limit);
      const v =
        typeof this.limit == "string" ? this.limit.replace("R$", "").replace(/\./g, "").replace(",", ".") : this.limit;
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 }).format(v);
    },
    newLimit() {
      return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 2 }).format(
        this.cacheLimit
      );
    },
  },
  data() {
    return {
      dialog: false,
      cacheLimit: 0,
      ruleForm: {
        limit: "R$ 0,00",
      },
    };
  },
  methods: {
    open() {
      this.cacheLimit = 0;
      this.ruleForm = {
        limit: "R$ 0,00",
      };
      this.dialog = true;
    },
    add() {
      const cache = this.ruleForm.limit.replace("R$", "").replace(/\./g, "").replace(",", ".");
      const limit =
        typeof this.limit == "string" ? this.limit.replace("R$", "").replace(/\./g, "").replace(",", ".") : this.limit;
      console.log("this.ruleForm.limit", this.ruleForm.limit, this.cacheLimit, cache);
      this.cacheLimit = +limit + +cache;
    },
    remove() {
      const cache = this.ruleForm.limit.replace("R$", "").replace(/\./g, "").replace(",", ".");
      const limit =
        typeof this.limit == "string" ? this.limit.replace("R$", "").replace(/\./g, "").replace(",", ".") : this.limit;
      console.log("this.ruleForm.limit", this.ruleForm.limit, this.cacheLimit, cache);
      this.cacheLimit = +limit - +cache;
    },
    save() {
      this.$emit("save", this.cacheLimit);
      this.dialog = false;
    },
  },
  mounted() {},
};
</script>
